var _path;
import * as React from "react";
function SvgChartArrow(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.353 21.353a1 1 0 001.415 0L16 18.121l5.293 5.293a1 1 0 001.415 0l6.888-6.889 1.843 1.844c.945.945 2.561.275 2.561-1.06V11a1 1 0 00-1-1h-6.308c-1.336 0-2.006 1.616-1.06 2.56l1.843 1.844L22 19.879l-5.293-5.293a1 1 0 00-1.415 0l-4.646 4.646a1 1 0 000 1.414l.707.707zM35 29H7V9a1 1 0 00-1-1H5a1 1 0 00-1 1v21a2 2 0 002 2h29a1 1 0 001-1v-1a1 1 0 00-1-1z"
  })));
}
export default SvgChartArrow;